// extracted by css-extract-rspack-plugin
export default {"areaSwitcherFooter":"area-switcher-footer--MDb5Uf_vrFoZeq9O"};